import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CatalogoRequest } from 'src/app/modal/catalogo/catalogo-request';
import { CatalogoResponse } from 'src/app/modal/catalogo/catalogo-response';
import { CarritoService } from 'src/app/service/carrito/carrito.service';
import { NovedadesService } from 'src/app/service/catalogo/novedades.service';
import { UsuarioService } from 'src/app/service/usuario/usuario.service';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { environment } from 'src/environments/environment';
import { ProtectedImageService } from 'src/app/service/catalogo/protected-image.service';
import { ProtectedImageResponse } from 'src/app/modal/catalogo/protected-image-response';

@Component({
  selector: 'app-hemeroteca',
  templateUrl: './hemeroteca.component.html',
  styleUrls: ['./hemeroteca.component.scss']
})
export class HemerotecaComponent implements OnInit {

  listHemeroteca:CatalogoResponse;
  flgAgregar:string = "0";

  // nlpr ini
  columnas = [[], [], []];
  // nlpr fin

  protectedImages: Map<string, ProtectedImageResponse> = new Map();

  constructor(private novedadesService:NovedadesService,
    private usuarioService:UsuarioService,
    private carritoService:CarritoService,
    private router : Router,
    private utilitarioService:UtilitarioService,
    private protectedImageService: ProtectedImageService
    ) { }

  buscarFotografias(){
    this.clearProtectedImagesCache(); // Limpiar cache antes de nueva búsqueda
    let catalogoRequest:CatalogoRequest;
    catalogoRequest = new CatalogoRequest();
    this.listHemeroteca = new CatalogoResponse();


    catalogoRequest.authorId="0";
    catalogoRequest.categoryId="0";
    //catalogoRequest.categoryName="PORTADAS_HISTORICAS";
    catalogoRequest.categoryName="HEMEROTECA_DIGITAL";
    catalogoRequest.page="1";
    catalogoRequest.subCategoryId="0";
    catalogoRequest.subCategoryName="";
    catalogoRequest.publicationId="0";
    catalogoRequest.size="6";
    catalogoRequest.title="";
    catalogoRequest.yearId="0";

    this.novedadesService.buscarCatalogo(catalogoRequest).subscribe(data=>{
      // console.log("hemeroteca",data);
      if(data.response.codeResponse=="0000"){
        this.listHemeroteca = data;

        // nlpr ini
        this.listHemeroteca.response.list.forEach((fila, index) => {
          const columnaIndex = index % 3;  // Determina en qué columna irá el elemento
          this.columnas[columnaIndex].push(fila);
          // Cargar imagen protegida para cada elemento
          this.loadProtectedThumbnail(fila.activoId);
        });
        // nlpr fin

      }
    })

  }


  onComprar(id){
    if(this.usuarioService.obtenerSesionUsuario()){
    let idLibro = id;
    let cantidad = "1";
    let tipoProducto = "1";
    let sizeID ="0";
    let libroArray = {};
    
    
    cantidad = "1";

    this.carritoService.obtenerCantidadCarrito();
    
    libroArray ={id:idLibro,cantidad:cantidad,tipoProducto:tipoProducto,sizeID:sizeID,modalidadId:1};
      //si agrega y limpio el carrito
      if((this.flgAgregar == "1") && ( this.carritoService.cantidadCarrito == 0)){
        this.carritoService.obtenerCantidadCarrito();
        this.carritoService.agregarCarrito(libroArray);
        this.router.navigate(['/procesarpago']);
        return;
      }
      //si no agrega, adiciona automaticamente al carrito
      if(this.flgAgregar == "0"){
      this.carritoService.obtenerCantidadCarrito();
      this.carritoService.agregarCarrito(libroArray);
      this.router.navigate(['/procesarpago']);
      return;
      }
      //si flag es 1 y no entra en las 2 condiciiones anteriores
      this.router.navigate(['/procesarpago']);
    }
    else{
      this.utilitarioService.toastrWarning("Necesita iniciar sesión")
    }
  }
  buscarConsulta(idCategoria,idSubCategoria){
    this.novedadesService.idCategoria=idCategoria;
    this.novedadesService.idSubCategoria=idSubCategoria;   
    this.router.navigateByUrl('/consultas/'+this.generaNss());
    //this.router.navigateByUrl('/hemerotecas/'+this.generaNss());
  }
  generaNss() {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < charactersLength; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
}

  loadProtectedThumbnail(imageId: string): void {
    // Verificar si ya existe el token y aún es válido
    if (this.protectedImages.has(imageId)) {
      const existingImage = this.protectedImages.get(imageId);
      const now = Date.now();
      const CACHE_DURATION = 5 * 60 * 1000; // 5 minutos de cache

      if (existingImage && existingImage.loadedAt && (now - existingImage.loadedAt) < CACHE_DURATION) {
        // console.log('Token de imagen reutilizado desde cache:', imageId);
        return; // Ya existe y es válido
      }
    }

    // Solo solicitar nuevo token si no existe o ha expirado
    this.protectedImageService.getProtectedThumbnail(imageId).subscribe({
      next: (response) => {
        response.loadedAt = Date.now(); // Agregar timestamp de carga
        this.protectedImages.set(imageId, response);
        // console.log('Token cargado para imagen:', imageId);
      },
      error: (error) => {
        console.error('Error cargando imagen protegida:', error);
      }
    });
  }

  getProtectedImageUrl(imageId: string): string | null {
    const protectedImage = this.protectedImages.get(imageId);
    return protectedImage?.protectedThumbnailUrl || null;
  }

  clearProtectedImagesCache(): void {
    // console.log('Limpiando cache de imágenes protegidas para nueva carga');
    // Solo limpiar tokens expirados en lugar de limpiar todo
    const now = Date.now();
    const CACHE_DURATION = 5 * 60 * 1000; // 5 minutos

    for (const [imageId, imageData] of this.protectedImages.entries()) {
      if (imageData.loadedAt && (now - imageData.loadedAt) > CACHE_DURATION) {
        this.protectedImages.delete(imageId);
        // console.log('Token expirado eliminado para imagen:', imageId);
      }
    }
  }

  ngOnInit(): void {
    this.clearProtectedImagesCache(); // Limpiar cache al inicializar
    this.buscarFotografias();
  }

  ngAfterViewInit(): void {
    // Agregar event listeners para efecto holográfico después de que la vista se inicialice
    setTimeout(() => {
      this.addHolographicEffectListeners();
    }, 500);
  }

  addHolographicEffectListeners(): void {
    const imageContainers = document.querySelectorAll('.panelFotografiaWeb .col-sm-6:first-child');

    imageContainers.forEach((container: HTMLElement) => {
      container.addEventListener('mousemove', (e: MouseEvent) => {
        const rect = container.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;

        container.style.setProperty('--mouse-x', `${x}%`);
        container.style.setProperty('--mouse-y', `${y}%`);

        // Efecto 3D siguiendo el mouse
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;

        const rotateX = ((mouseY - centerY) / centerY) * -5;
        const rotateY = ((mouseX - centerX) / centerX) * 5;

        container.classList.add('imagen-3d');
        container.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
      });

      container.addEventListener('mouseleave', () => {
        container.classList.remove('imagen-3d');
        container.style.transform = '';
        container.style.setProperty('--mouse-x', '50%');
        container.style.setProperty('--mouse-y', '50%');
      });
    });
  }

}
